var map = {
	"./arrow-down.svg": 807,
	"./arrow-up.svg": 808,
	"./circle-check-solid.svg": 809,
	"./circle-regular.svg": 810,
	"./doc.svg": 811,
	"./list-product.svg": 812,
	"./list-shop.svg": 813,
	"./loading-spinner.svg": 814,
	"./qrcode.svg": 815,
	"./shangchuanba.svg": 816,
	"./share-like-active.svg": 817,
	"./share-like.svg": 818,
	"./share-product.svg": 819,
	"./share-shop.svg": 820,
	"./share-word.svg": 821,
	"./ship.svg": 822,
	"./sort-down-solid.svg": 823,
	"./sort-solid.svg": 824,
	"./sort-up-solid.svg": 825,
	"./tab-1.svg": 826,
	"./tab.svg": 827,
	"./wechat-qrcode.svg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;